export const Block24Icon = ({
  label,
  color
}: {
  label: string;
  color: string;
}) => {
  return (
    <div
      aria-label={label}
      style={{
        width: 25,
        height: 25,
        borderRadius: 5,
        backgroundColor: color
      }}
    />
  );
};
